module.exports = __webpack_public_path__ + "img/help.3fb6e610.svg";